import call from "./call";
import {
  VoicesCompanyVoice,
  VoicesConfig,
  VoicesConfigPayload,
  VoicesSchedule,
} from "../Models/voicesConfig";
import { VoicesWorkspace } from "../Models/voicesProfiles";
import { voicesHeaders } from "../Helpers/voicesWorkspace";

export const getVoicesConfig = async (): Promise<VoicesConfig> => {
  const response = await call.get<VoicesConfig>("/v1/voices/config/", {
    headers: voicesHeaders(),
    snack: { error: "voices.configFetchError" },
  });
  return response.data;
};

export const updateVoicesConfig = async (
  data: Partial<VoicesConfigPayload & VoicesCompanyVoice>,
): Promise<VoicesConfig> => {
  const response = await call.put<VoicesConfig>("/v1/voices/config/", data, {
    headers: voicesHeaders(),
    snack: {
      success: "voices.configUpdateSuccess",
      error: "voices.configUpdateError",
    },
  });
  return response.data;
};

export const setVoicesBufferKey = async (
  apiKey: string,
): Promise<VoicesConfig> => {
  const response = await call.put<VoicesConfig>(
    "/v1/voices/config/buffer_key/",
    { api_key: apiKey },
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.bufferKeySaveSuccess",
        error: "voices.bufferKeySaveError",
      },
    },
  );
  return response.data;
};

export const removeVoicesBufferKey = async (): Promise<VoicesConfig> => {
  const response = await call.delete<VoicesConfig>(
    "/v1/voices/config/buffer_key/",
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.bufferKeyRemoveSuccess",
        error: "voices.bufferKeyRemoveError",
      },
    },
  );
  return response.data;
};

export const getVoicesWorkspaces = async (): Promise<VoicesWorkspace[]> => {
  const response = await call.get<{ workspaces: VoicesWorkspace[] }>(
    "/v1/voices/config/workspaces/",
    { snack: { error: "voices.workspacesFetchError" } },
  );
  return response.data.workspaces;
};

export const getVoicesSchedules = async (): Promise<VoicesSchedule[]> => {
  const response = await call.get<{ schedules: VoicesSchedule[] }>("/v1/voices/config/schedules/", {
    headers: voicesHeaders(),
  });
  return response.data.schedules;
};

export const updateVoicesSchedule = async (
  taskKey: string,
  data: { cron_expression?: string; enabled?: boolean },
): Promise<VoicesSchedule> => {
  const response = await call.put<VoicesSchedule>(
    `/v1/voices/config/schedules/${taskKey}/`,
    data,
    {
      headers: voicesHeaders(),
      snack: { success: "voices.scheduleUpdateSuccess", error: "voices.scheduleUpdateError" },
    },
  );
  return response.data;
};
